import { Link } from 'react-router-dom';
import { Logo } from '@/components/Logo';
import { Button } from '@/components/ui/Button';
import { AnalysisFlow } from '@/components/AnalysisFlow';

export function Analyze() {
  return (
    <div className="min-h-full">
      <header className="border-b border-border/70 bg-bg/80 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-5xl items-center justify-between px-4 sm:px-6">
          <Link to="/" aria-label="Visiward home">
            <Logo />
          </Link>
          <div className="flex items-center gap-2">
            <Link to="/login">
              <Button variant="ghost" size="sm">
                Sign in
              </Button>
            </Link>
            <Link to="/sample-report">
              <Button variant="secondary" size="sm">
                Sample report
              </Button>
            </Link>
          </div>
        </div>
      </header>

      <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6">
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-bold tracking-tight text-text-primary">
            Analyze your website
          </h1>
          <p className="mx-auto mt-2 max-w-xl text-text-secondary">
            Enter your website URL. We’ll inspect it, infer your brand for you to confirm, and run a
            free visibility analysis.
          </p>
        </div>
        <AnalysisFlow mode="anonymous" />
        <p className="mx-auto mt-6 max-w-2xl text-center text-xs text-text-muted">
          Anonymous analyses are temporary and expire after 24 hours. Create a free account to save
          your report and track changes over time.
        </p>
      </div>
    </div>
  );
}
